import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import { ToolIdType } from '../CurrentToolIdContext';
import {
  createCurrentIdStore,
  CurrentIdStore,
} from '../helpers/createCurrentIdStore';

const FIELD_NAME = 'toolId';

export type CurrentToolIdContextStore = CurrentIdStore<
  typeof FIELD_NAME,
  ToolIdType
>;

export const useCurrentToolIdStore = createCurrentIdStore<
  typeof FIELD_NAME,
  ToolIdType
>({
  contextName: CONTEXT_NAMES.CurrentToolIdContext,
  fieldName: FIELD_NAME,
});
